import { useMemo, useState, useRef, useContext } from "react"
import { UserContext } from "../../store/store"
import toast from "react-hot-toast"
import { ModalEditorCrosswords } from "../../components/admin/ModalEditorCrosswords"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { ModalEliminarJuego } from "../../components/admin/ModalEliminarJuego"
import { config } from "../../config"
import { ModalCompartir } from "../../components/admin/ModalCompartir"

import { useQuery } from "../../hooks/useQuery"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ModalOk } from "../../components/ui/modal/ModalOk"
import { msg } from "../../components/ui/modal/utils"
import { ModalEliminarStory } from "../../components/admin/ModalEliminarStory"
import { ModalEditarStory } from "../../components/admin/ModalEditarStory"
import { dificultades, tamanos } from "../../services/statics"
import { Trans, useTranslation } from "react-i18next"
import { asciify, checkAlphanum, kebabify } from "../../helpers/utils"
import { Switch } from "../../components/ui/Switch"
import { ModalNuevoJuegoRow } from "../../components/admin/ModalNuevoJuegoRow"

const UID = ({ game, name, setName, disabled }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="form-group mb-4">
        <label className="form-label w-100 mb-0">{t(`admin.games.id`)}</label>
        <small className="form-text text-muted">
          ({t(`admin.games.alphanumeric_only`)})
        </small>
        <input
          onChange={(e) => setName(e.target.value)}
          disabled={disabled}
          placeholder={"eg: " + t(`admin.games.placeholder`)}
          className="form-control mt-1"
          type="text"
        />
        <small className="form-text text-muted">
          {window.location.host}/{game}/
          {name ? name : t(`admin.games.placeholder`)}
        </small>
      </div>
    </>
  )
}

const NuevoCrosswords = () => {
  const [origenPalabras, setOrigenPalabras] = useState("db"),
    modal = useState(false),
    [size, setSize] = useState(null),
    [tag, setTag] = useState(null),
    [name, setName] = useState(""),
    [text, setText] = useState(""),
    sizeEl = useRef(),
    catEl = useRef()

  const handleTextChange = (event) => {
    setText(event.target.value)
  }

  const { t } = useTranslation()

  // tags
  const { url, opt } = useMemo(() => api.tags.readAll({}), []),
    [tags, isPending, err] = useFetch({ url, opt }),
    SelectTag = () => {
      if (isPending && !err) return <span>{t(`ui.btns.loading`)}...</span>

      return (
        <select
          ref={catEl}
          className="form-select mini-select mx-2"
          style={{ fontSize: "14px" }}>
          {tags.entries.map((tag, ix) => (
            <option key={ix} value={tag.name}>
              {tag.name}
            </option>
          ))}
        </select>
      )
    }

  const handleChange = (e) => setOrigenPalabras(e.target.value)

  const showModalEditor = (e) => {
    let ok = checkAlphanum(name, { allowSpaces: false, allowHyphen: true })
    if (!ok) {
      toast.error(t(`modals.modal_create_game_row.game_name_err`))
      return
    }
    e.preventDefault()
    const size = parseInt(sizeEl.current.value),
      cat = catEl.current.selectedOptions[0].label

    setSize(size)
    setTag(cat)

    modal[1](true)
  }

  return (
    <>
      {modal[0] && (
        <ModalEditorCrosswords
          name={name}
          show={modal}
          size={size}
          tag={tag}
          text={text}
          origenPalabras={origenPalabras}
        />
      )}

      <div className="col-lg-10 col-12" style={{ margin: "0 auto" }}>
        <legend>{t(`admin.games.new_crosswords`)}</legend>

        <UID game={"crosswords"} name={name} setName={setName} />

        <div className="form-group mb-4">
          <label className="form-label">
            {t(`ui.games.headers.choose_puzzle_size`)}
          </label>
          <select
            ref={sizeEl}
            className="form-select"
            style={{ width: "auto" }}>
            {tamanos.map((t, ix) => (
              <option key={ix} value={t}>
                {t + "x" + t}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group mb-4">
          <Trans
            i18nKey="admin.games.use_words_with"
            components={{ SelectTag: <SelectTag /> }}
          />
        </div>

        <fieldset className="form-group mt-4">
          <label className="form-label">{t(`admin.games.words`)}</label>

          <div className="form-check">
            <label className="form-check-label">
              <input
                type="radio"
                onChange={handleChange.bind(this)}
                name={t(`admin.games.words`).toLowerCase()}
                className="form-check-input me-3"
                value="db"
                defaultChecked
              />
              {t(`admin.games.only_database`)}
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                type="radio"
                onChange={handleChange.bind(this)}
                name="palabras"
                className="form-check-input me-3"
                value="texto"
              />
              {t(`admin.games.given_text`)}
            </label>
          </div>

          {origenPalabras === "texto" && (
            <textarea
              className="form-control mt-3"
              rows="3"
              value={text}
              onChange={handleTextChange}
              placeholder={t(`admin.games.insert_text_here`)}></textarea>
          )}
        </fieldset>

        <center>
          <button
            type="submit"
            onClick={showModalEditor.bind(this)}
            className="btn btn-primary mt-4">
            {t(`admin.games.new_game`)}
          </button>
        </center>
      </div>
    </>
  )
}

const NuevoWordsearch = ({ setMenu }) => {
  const [name, setName] = useState(""),
    [text, setText] = useState(""),
    sizeEl = useRef(),
    diffEl = useRef()

  const cleanForm = () => {
    setName("")
    setText("")
  }

  const query = useQuery(),
    showRes = useState(false)

  const runQuery = async () => {
    let ok = checkAlphanum(name, { allowSpaces: false, allowHyphen: true })
    if (!ok) {
      toast.error(t(`modals.modal_create_game_row.game_name_err`))
      return
    }

    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      { url, opt } = api.games.Wordsearch.Post({
        token: tkn,
        name,
        size: parseInt(sizeEl.current.value),
        diff: diffEl.current.value,
        text,
      })

    // ejecuto
    query.url.current = url
    query.opt.current = opt
    query.run({})
  }

  const { t } = useTranslation()

  return (
    <>
      {!query.isPending && query.res && query.err && (
        <ModalError show={showRes} res={query.res} />
      )}

      {!query.isPending && query.res && !query.err && (
        <ModalOk
          show={showRes}
          body={msg(t(`admin.games.succesfuly_added_game`, { name: name }))}
          onClick={() => {
            cleanForm()
            showRes[1](false)
            window.location.hash = `#` + kebabify(t(`admin.menu.games.manage`))
            window.scrollTo({ top: 0, behavior: "smooth" })
            setMenu(kebabify(t(`admin.menu.games.manage`)))
          }}
        />
      )}

      <div className="col-lg-10 col-12" style={{ margin: "0 auto" }}>
        <legend>{t(`admin.games.new_wordsearch`)}</legend>

        <UID
          game={"wordsearch"}
          name={name}
          setName={setName}
          disabled={query.isPending}
        />

        <div className="form-group mb-4">
          <label className="form-label">
            {t(`ui.games.headers.choose_a_difficulty`)}
          </label>
          <select
            ref={diffEl}
            disabled={query.isPending}
            className="form-select"
            style={{ width: "auto" }}>
            {dificultades
              .filter((d) => !["imgs"].includes(d.code))
              .map((d, ix) => (
                <option key={ix} value={d.code}>
                  {d.nivel + ": " + d.title}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group mb-4">
          <label className="form-label">
            {t(`ui.games.headers.choose_puzzle_size`)}
          </label>
          <select
            ref={sizeEl}
            disabled={query.isPending}
            className="form-select"
            style={{ width: "auto" }}>
            {tamanos.map((t, ix) => (
              <option key={ix} value={t}>
                {t + "x" + t}
              </option>
            ))}
          </select>
        </div>

        <fieldset className="form-group mt-4">
          <label className="form-label">{t(`admin.games.text`)}</label>
          <textarea
            className="form-control"
            disabled={query.isPending}
            onChange={(e) => setText(e.target.value)}
            style={{ minHeight: "40vh" }}
            rows="3"
            placeholder={t(`admin.games.insert_text_here`)}></textarea>
        </fieldset>

        <center>
          <button
            type="submit"
            disabled={query.isPending}
            onClick={() => runQuery()}
            className="btn btn-primary mt-4">
            {query.isPending
              ? t(`admin.games.creating`) + "..."
              : t(`admin.games.create_new_game`)}
          </button>
        </center>
      </div>
    </>
  )
}

const NuevoSeaAnimals = () => {
  const { t } = useTranslation()
  return <h2>{t(`admin.games.new_sea_animals`)}</h2>
}

const AgregarStoryForm = () => {
  // elements
  const form = useRef()

  // estado
  const [title, setTitle] = useState(""),
    [text, setText] = useState(""),
    [isPublic, setIsPublic] = useState(false)

  // pal msg de ok
  const [cache, setCache] = useState("")

  const createStory = useQuery(),
    showRes = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setCache(title)
    setText("")
    setTitle("")
    setIsPublic(false)
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = api.stories.create({
      token: getCookie("jwt"),
      story: {
        text,
        title,
        public: isPublic,
      },
    })

    createStory.url.current = url
    createStory.opt.current = opt
    createStory.run({
      onOk: cleanForm,
    })
  }

  const { t } = useTranslation()

  return (
    <>
      {createStory.res && !createStory.err && (
        <ModalOk
          show={showRes}
          body={msg(
            <Trans
              i18nKey="admin.games.story_succesfully_added"
              values={{ name: cache }}
              components={{ i: <i /> }}
            />
          )}
        />
      )}

      {createStory.res && createStory.err && (
        <ModalError id="err-res" show={showRes} res={createStory.res} />
      )}

      <div className="col-9" style={{ margin: "0 auto" }}>
        <form ref={form}>
          <fieldset>
            <legend>{t(`admin.games.new_story`)}</legend>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.games.title`)}
              </label>
              <input
                onChange={(e) => setTitle(e.target.value)}
                className="form-control"
                placeholder={t(`admin.games.placeholder_story_title`)}
              />
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`modals.modal_edit_story.public`)}
              </label>
              <input
                type="checkbox"
                className="ms-2 me-3"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
              />
            </div>

            <div className="form-group">
              <label className="form-label mt-4">{t(`admin.games.text`)}</label>
              <textarea
                onChange={(e) => setText(e.target.value)}
                style={{ minHeight: "15vw" }}
                placeholder={t(`admin.games.placeholder_story_content`)}
                className="form-control"></textarea>
            </div>

            <button
              onClick={onSubmitForm.bind(this)}
              disabled={createStory.isPending}
              type="submit"
              className="btn btn-primary mt-5">
              {createStory.isPending
                ? t(`ui.btns.submiting`) + "..."
                : t(`ui.btns.create`)}
            </button>
          </fieldset>
        </form>
      </div>
    </>
  )
}

export const CrearJuego = ({ setMenu }) => {
  const [tab, setTab] = useState("Crosswords")

  const handleClick = (e) => {
    e.preventDefault()
    setTab(e.target.innerHTML)
  }

  const tabs = ["Crosswords", "Wordsearch", "SeaAnimals", "Stories"]

  const colStyle = { margin: "0 auto" }

  const ulStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  }

  return (
    <div className="col-lg-8 col-12" style={colStyle}>
      <ul className="nav nav-tabs mb-4" style={ulStyle}>
        {tabs.map((t, ix) => (
          <li key={ix} className="nav-item">
            <a
              className={"nav-link" + (t === tab ? " active" : "")}
              href="/#"
              onClick={handleClick.bind(this)}>
              {t}
            </a>
          </li>
        ))}
      </ul>

      {tab === "Crosswords" && <NuevoCrosswords />}
      {tab === "Wordsearch" && <NuevoWordsearch setMenu={setMenu} />}
      {tab === "SeaAnimals" && <NuevoSeaAnimals />}
      {tab === "Stories" && <AgregarStoryForm />}
    </div>
  )
}

export const GestionarJuegosEstaticos = () => {
  const { url, opt } = useMemo(() => api.games.read_all({}), [])
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const modalEliminar = useState(false),
    [editGame, setEditGame] = useState(null),
    modalCompartir = useState(false),
    [link, setLink] = useState(null)

  const make_url = (g) => `${config.base}/${g.game}/${g.uid}`

  const onClickCopy = (game, e) => {
    e.preventDefault()
    setLink(make_url(game))
    modalCompartir[1](true)
  }

  const onClickEliminar = (game, e) => {
    e.preventDefault()
    setEditGame(game)
    modalEliminar[1](true)
  }

  const { t } = useTranslation()

  const ListGames = (games) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>UID</th>
            <th>{t(`admin.games.game_type`)}</th>
            <th>{t(`ui.tables.by`)}</th>
            <th>{t(`ui.tables.date`)}</th>
            <th>
              <center>{t(`ui.tables.link`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.share`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {games.map((g, ix) => (
            <tr key={ix}>
              <td>{g.id}</td>
              <td>{g.uid}</td>
              <td>{g.game}</td>
              <td>{g.author}</td>
              <td>{g.timestamp.slice(0, 10)}</td>
              <td>
                <center>
                  <a
                    type="button"
                    rel="noreferrer"
                    target="_blank"
                    href={make_url(g)}
                    className="btn btn-sm text-decoration-none">
                    🔗
                  </a>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickCopy.bind(this, g)}
                    className="btn btn-sm tooltip copy-tooltip">
                    📋
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, g)}
                    className="btn btn-sm tooltip elim-tooltip">
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEliminar[0] && (
        <ModalEliminarJuego
          show={modalEliminar}
          game={editGame}
          setGames={setData}
        />
      )}

      {modalCompartir[0] && (
        <ModalCompartir show={modalCompartir} link={link} />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListGames(data)}
      </div>
    </>
  )
}

const GestionarStories = () => {
  const token = getCookie("jwt")
  const { url, opt } = useMemo(() => api.stories.readAll({ token }), [token])
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const modalEliminar = useState(false),
    modalEditar = useState(false),
    [editStory, setEditStory] = useState(null)

  // modal compartir
  const modalCompartir = useState(false)
  const [link, setLink] = useState(null)

  const onClickEliminar = (story, e) => {
    e.preventDefault()
    setEditStory(story)
    modalEliminar[1](true)
  }

  const onClickEditar = (entry, e) => {
    e.preventDefault()
    modalEditar[1](true)
    setEditStory(entry)
  }

  const { t } = useTranslation()

  const make_url = (s) =>
    `${config.base}/story/${asciify(s.title).toLowerCase()}`

  const onClickCopy = (story, e) => {
    e.preventDefault()
    setLink(make_url(story))
    modalCompartir[1](true)
  }

  const ListStories = ({ stories }) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>{t(`admin.games.story`)}</th>
            <th>
              <center>{t(`ui.tables.public`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.edit`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.link`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.share`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {stories.map((story, ix) => (
            <tr key={ix}>
              <td>{story.id}</td>
              <td>{story.title}</td>
              <td>
                <center>{story.public ? "Sí" : "No"}</center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEditar.bind(this, story)}
                    className="btn btn-sm tooltip edit-tooltip">
                    ✏️
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <a
                    type="button"
                    rel="noreferrer"
                    target="_blank"
                    href={make_url(story)}
                    className="btn btn-sm text-decoration-none">
                    🔗
                  </a>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickCopy.bind(this, story)}
                    className="btn btn-sm tooltip copy-tooltip">
                    📋
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, story)}
                    className="btn btn-sm tooltip elim-tooltip">
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEliminar[0] && (
        <ModalEliminarStory
          show={modalEliminar}
          story={editStory}
          setStories={setData}
        />
      )}

      {modalEditar[0] && (
        <ModalEditarStory
          show={modalEditar}
          entry={editStory}
          setEntries={setData}
        />
      )}

      {modalCompartir[0] && (
        <ModalCompartir show={modalCompartir} link={link} />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        {isPending && <p className="my-3">{t("ui.btns.loading")}...</p>}
        {err && <p className="my-3">{t("ui.games.msgs.error")}</p>}
        {!isPending && data && <ListStories stories={data.entries} />}
      </div>
    </>
  )
}

export const GestionarJuegos = () => {
  const { t } = useTranslation()

  const [tab, setTab] = useState(kebabify(t(`admin.games.static_games`)))

  const handleClick = (e) => {
    e.preventDefault()
    setTab(kebabify(e.target.innerHTML))
  }

  const tabs = [t(`admin.games.static_games`), t(`admin.games.stories`)]

  const on = (x) => tab === kebabify(t(x))

  const colStyle = { margin: "0 auto" }

  const ulStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  }

  return (
    <div className="col-12" style={colStyle}>
      <ul className="nav nav-tabs mb-4" style={ulStyle}>
        {tabs.map((t, ix) => (
          <li key={ix} className="nav-item">
            <a
              className={"nav-link" + (kebabify(t) === tab ? " active" : "")}
              href="/#"
              onClick={handleClick.bind(this)}>
              {t}
            </a>
          </li>
        ))}
      </ul>

      {on(`admin.games.static_games`) && <GestionarJuegosEstaticos />}
      {on(`admin.games.stories`) && <GestionarStories />}
    </div>
  )
}

export const JuegosHabilitados = () => {
  const tkn = getCookie("jwt"),
    { url, opt } = useMemo(() => api.game_management.readAll(), []),
    [data, isPending, err, setData] = useFetch({ url, opt })

  const { t } = useTranslation()

  const query = useQuery()

  const [modalCreate, setModalCreate] = useState(false)

  const edit = (id) => () => {
    const old = data.find((x) => x.id === id)
    const newEntry = { enabled: !old.enabled }

    // local
    setData((current) =>
      current.map((c) => {
        if (c.id !== id) return c
        return { ...c, ...newEntry }
      })
    )

    // remoto
    const { url, opt } = api.game_management.update({
      token: tkn,
      id,
      game: { ...old, ...newEntry },
    })
    query.url.current = url
    query.opt.current = opt
    query.run({
      onOk: () => {
        const s = newEntry.enabled ? "enabled" : "disabled"
        toast.success(
          <span>
            <Trans
              i18nKey={`admin.games.has_been_${s}`}
              values={{ name: old.id + " " }}
              components={[<i />]}
            />
          </span>
        )
      },
      onErr: () => {
        toast.error(t("ui.games.msgs.error"))
      },
    })
  }

  const del = (id) => {
    // local
    setData((current) => current.filter((c) => c.id !== id))

    // remoto
    const { url, opt } = api.game_management.delete({
      token: tkn,
      id,
    })

    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: () => {
        toast.success(
          <span>
            <Trans
              i18nKey={`admin.games.has_been_deleted`}
              values={{ name: id + " " }}
              components={[<i />]}
            />
          </span>
        )
      },
      onErr: () => {
        toast.error(t("ui.games.msgs.error"))
      },
    })
  }

  const List = ({ games }) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>
              <center>{t(`admin.games.enabled`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {games.map((game, ix) => (
            <tr key={ix}>
              <td style={{ verticalAlign: "middle" }}>{game.id}</td>
              <td style={{ verticalAlign: "middle" }}>
                <center>
                  <Switch status={game.enabled} setStatus={edit(game.id)} />
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={() => del(game.id)}
                    className="btn btn-sm tooltip elim-tooltip">
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalCreate && (
        <ModalNuevoJuegoRow
          show={[modalCreate, setModalCreate]}
          setEntries={setData}
        />
      )}

      <div className="col-lg-8 col-12" style={{ margin: "0 auto" }}>
        <div className="d-flex justify-content-between bd-highlight">
          <div className="bd-highlight">
            <h2>{t(`admin.games.enabled_games`)}</h2>
          </div>

          <div className="bd-highlight">
            <button
              type="submit"
              onClick={() => setModalCreate(true)}
              className="btn btn-primary">
              {t(`admin.games.add_game`)}
            </button>
          </div>
        </div>

        <div className="alert alert-warning my-4" role="alert">
          <Trans
            i18nKey="admin.games.warning_cache"
            components={{ b: <b /> }}
          />
        </div>

        {isPending && <p className="my-3">{t("ui.btns.loading")}...</p>}
        {err && <p className="my-3">{t("ui.games.msgs.error")}</p>}
        {!isPending && data && <List games={data} />}
      </div>
    </>
  )
}
